import { render, staticRenderFns } from "./PnrValidationForm.vue?vue&type=template&id=830e7eb8&scoped=true&"
import script from "./PnrValidationForm.vue?vue&type=script&lang=ts&"
export * from "./PnrValidationForm.vue?vue&type=script&lang=ts&"
import style0 from "./PnrValidationForm.vue?vue&type=style&index=0&id=830e7eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830e7eb8",
  null
  
)

export default component.exports